<template>
  <div class="row dashboard__card-body dashboard__card-body--no-min">
    <div class="dashboard__grid dash-library__content-container dash-library__content-container--no-min" v-if="accounts">
      <div class="col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered">
        <table class="maincol__table dash-accounts__list">
          <tr class="table__row table__row--head">
            <td class="table__cell table__cell--head table__cell--name">Location</td>
            <td class="table__cell table__cell--head">Oticon</td>
            <td class="table__cell table__cell--head">Resound</td>
            <td class="table__cell table__cell--head">Signia</td>
            <td class="table__cell table__cell--head">Sonic</td>
            <td class="table__cell table__cell--head">Starkey</td>
            <td class="table__cell table__cell--head">Widex</td>
          </tr>
          <tr class="table__row">
            <td class="table__cell">Customer Service #s</td>
            <td class="table__cell h-center-align h-helper-text">(800) 526-3921</td>
            <td class="table__cell h-center-align h-helper-text">(800) 248-4327</td>
            <td class="table__cell h-center-align h-helper-text">(800) 766-4500</td>
            <td class="table__cell h-center-align h-helper-text">(888) 423-7834</td>
            <td class="table__cell h-center-align h-helper-text">(800) 328-8602</td>
            <td class="table__cell h-center-align h-helper-text">(800) 221-0188</td>
          </tr>
          <tr class="table__row">
            <td class="table__cell">Online Ordering</td>
            <td class="table__cell h-center-align h-helper-text"><a href="https://www.myoticon.com/login" target="_blank">Oticon <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span></a></td>
            <td class="table__cell h-center-align h-helper-text"><a href="https://pro.resound.com/en-us" target="_blank">Resound <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span></a></td>
            <td class="table__cell h-center-align h-helper-text"><a href="https://www3.mysigniausa.com/customer/account/login/" target="_blank">Signia <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span></a></td>
            <td class="table__cell h-center-align h-helper-text">&nbsp;</td>
            <td class="table__cell h-center-align h-helper-text"><a href="https://starkeypro.com/login?/estore" target="_blank">Starkey <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span></a></td>
            <td class="table__cell h-center-align h-helper-text"><a href="https://www.widexpro.com/en-us/" target="_blank">Widex <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span></a></td>
          </tr>
          <tr class="table__row" v-if="hasPricingPolicyGuides">
            <td class="table__cell">Pricing & Policy Guide</td>
            <td class="table__cell h-center-align h-helper-text">
              <a v-if="accounts.vendors.hasOwnProperty('Oticon')" v-bind:href="accounts.vendors.Oticon" target="_blank">Oticon <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>
            </td>
            <td class="table__cell h-center-align h-helper-text">
              <a v-if="accounts.vendors.hasOwnProperty('ReSound')" v-bind:href="accounts.vendors.ReSound" target="_blank">Resound <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>
            </td>
            <td class="table__cell h-center-align h-helper-text">
              <a v-if="accounts.vendors.hasOwnProperty('Signia')" v-bind:href="accounts.vendors.Signia" target="_blank">Signia <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>
            </td>
            <td class="table__cell h-center-align h-helper-text">
              <a v-if="accounts.vendors.hasOwnProperty('Sonic')" v-bind:href="accounts.vendors.Sonic" target="_blank">Sonic <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>
            </td>
            <td class="table__cell h-center-align h-helper-text">
              <a v-if="accounts.vendors.hasOwnProperty('Starkey')" v-bind:href="accounts.vendors.Starkey" target="_blank">Starkey <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>
            </td>
            <td class="table__cell h-center-align h-helper-text">
              <a v-if="accounts.vendors.hasOwnProperty('Widex')" v-bind:href="accounts.vendors.Widex" target="_blank">Widex <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>
            </td>
          </tr>
          <Location v-for="(location, index) in accounts" :key="index" :location="location.location" :accounts="location.accounts"></Location>
        </table>
      </div>
    </div>
    <div class="dashboard__grid dashboard__alert alert alert-warning" v-else-if="loaders.accounts == false && initializers.accounts == true">
      <div class="dashboard__no-data">No location information available</div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import Location from './Location.vue';

  export default {
    name: 'Locations',
    components: {
      Location,
    },
    computed: {
      ...mapGetters('accounts', ['loaders', 'initializers', 'accounts']),
      hasPricingPolicyGuides() {
        return lodash.filter(this.accounts.vendors, (vendor) => vendor !== '').length > 0;
      }
    },
    mounted() {
      if (!this.initializers.locations) {
        this.$store.dispatch('accounts/getAccounts');
      }
    },
  };
</script>
